export const options = {
  general: 'general',
  psycological: 'psycological',
  financial: 'financial'
}
